import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';
import { DepositPlayplusComponent } from './deposit-playplus.component';
import { DepositPlayplusActionComponent } from './deposit-playplus-action.component';


@NgModule({
  declarations: [
    DepositPlayplusActionComponent,
    DepositPlayplusComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule
  ]
})
export class DepositPlayplusModule {}